import firebase from "firebase";
import "firebase/firestore";

firebase.initializeApp({
  apiKey: "AIzaSyCIizYbACfNJzxvuo-5EDce7arFbDEsoXA",
  authDomain: "icebreaker-f8.firebaseapp.com",
  databaseURL: "https://icebreaker-f8.firebaseio.com",
  projectId: "icebreaker-f8",
  storageBucket: "icebreaker-f8.appspot.com",
  messagingSenderId: "989953311646"
});
const db = firebase.firestore();

export default { db };



// WEBPACK FOOTER //
// ./src/firebase.js